
import { createColumnHelper } from "@tanstack/react-table";
import { useNavigate } from "react-router-dom";
import { useDeleteBrand, useGetBrands } from "../../queries/brand";
import { useMemo } from "react";
import Chip from "../../components/Chip";
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from "react-toastify";
import TanStackTable from "../../components/TanStackTable";
import { FaTrash } from "react-icons/fa";
const EditIcon = require("../../utils/media/icons/edit_icon.png");

const ListBrands = () => {
    const navigate = useNavigate();

    const { data, isPending } = useGetBrands();
    const { mutateAsync: deleteBrand, isPending: isDeleting } = useDeleteBrand();

    const columnHelper = createColumnHelper();

    const columns = useMemo(() => [
        columnHelper.display({
            id: 'srno',
            header: 'Sr No.',
            cell: info => info.row.index + 1,
        }),
        columnHelper.accessor('brandName', {
            header: 'Brand Name',
            cell: info => (
                <div className="whitespace-normal break-words line-clamp-2">
                    {info.getValue() || 'N/A'}
                </div>
            ),
        }),
        columnHelper.accessor('companyId.name', {
            header: 'Company/NGO',
            cell: info => (
                <div className="whitespace-normal break-words line-clamp-2">
                    {info.row.original?.companyId?.companyName ||
                        info.row.original?.ngoId?.ngoName ||
                        'N/A'}
                </div>
            ),
        }),
        columnHelper.accessor('createdAt', {
            header: 'Created Date',
            cell: info => (
                <div className="whitespace-normal break-words line-clamp-1">
                    {info.getValue() ? new Date(info.getValue()).toLocaleDateString('en-GB') : 'N/A'}
                </div>
            ),
        }),
        columnHelper.accessor('isActive', {
            header: () => <div className="text-center">Status</div>,
            size: 10,
            align: 'center',
            cell: info => (
                <Chip value={info.getValue() ? 'Active' : 'Inactive'} color={info.getValue() ? 'green' : 'inactive'} />
            ),
        }),
        columnHelper.accessor('actions', {
            header: () => <div className="text-center">Actions</div>,
            enableColumnFilter: false,
            cell: info => {
                return (
                    <div className='flex items-center justify-center'>
                        <button
                            className="rounded p-1.5 bg-[rgba(52,199,89,0.1)] hover:bg-[rgba(52,199,89,0.2)] mx-1 min-h-7 min-w-7"
                            onClick={() => navigate('/brands/create-brand', { state: { brandId: info.row.original?._id } })}
                        >
                            <img src={EditIcon} alt="edit" />
                        </button>
                        <button
                            className="rounded p-1.5 bg-[rgba(199,52,52,0.1)] hover:bg-[rgba(199,52,52,0.2)] mx-1 min-h-7"
                            onClick={() => {
                                handleDelete(info.row.original._id);
                            }}
                        >
                            <FaTrash className="fill-chipRed" />
                        </button>
                    </div>
                )
            },
        }),
    ], [navigate]);

    const handleDelete = async (id) => {
        const confirm = window.confirm("Are you sure you want to delete this brand?");
        if (!confirm) return;
        deleteBrand(id, {
            onSuccess: () => {
                toast.success('Brand deleted successfully');
            },
            onError: (error) => {
                toast.error(`Error deleting brand: ${error.message || 'Unknown error'}`);
            },
        });
    }

    if (isPending) {
        return (
            <main className="flex flex-col text-base font-semibold text-gray-900 rounded-none">
                <section className="flex flex-col pt-5 w-full mt-5 bg-white rounded-md shadow-[0px_0px_25px_rgba(94,92,154,0.1)] max-md:max-w-full">
                    <div className="flex flex-col pr-px pl-6 w-full max-md:pl-5 max-md:max-w-full">
                        <h1 className="self-start text-lg font-semibold">List of Brands</h1>
                        <p>Loading...</p>
                    </div>
                </section>
            </main>
        );
    }

    return (
        <div>
            <section className="flex flex-col pt-5 w-full mt-5 bg-white rounded-md shadow-[0px_0px_25px_rgba(94,92,154,0.1)] max-md:max-w-full">
                <div className="flex flex-col pr-px w-full max-md:max-w-full">
                    <h1 className="self-start text-lg font-bold pl-6 pb-4">List of Brands</h1>
                    <div className="pl-5">
                        <TanStackTable
                            data={data || []}
                            columns={columns}
                            enablePagination={true}
                        />
                    </div>
                </div>
            </section>
            <ToastContainer
                position="top-right"
                autoClose={3000}
            />
        </div>
    );
}

export default ListBrands;